import { createContext, useContext, useState, useCallback } from 'react';

const RecaptchaContext = createContext(null);

export const RecaptchaProvider = ({ children }) => {
  const [ReCAPTCHA, setReCAPTCHA] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const loadRecaptcha = useCallback(async () => {
    if (!ReCAPTCHA && !isLoading && !isLoaded) {
      setIsLoading(true);
      try {
        const { default: Component } = await import('react-google-recaptcha');
        setReCAPTCHA(() => Component);
        setIsLoaded(true);
      } catch (error) {
        console.error('Failed to load reCAPTCHA:', error);
      } finally {
        setIsLoading(false);
      }
    }
  }, [ReCAPTCHA, isLoading, isLoaded]);

  return (
    <RecaptchaContext.Provider value={{ ReCAPTCHA, loadRecaptcha, isLoaded, isLoading }}>
      {children}
    </RecaptchaContext.Provider>
  );
};

export const useRecaptcha = () => {
  const context = useContext(RecaptchaContext);
  if (!context) {
    throw new Error('useRecaptcha must be used within RecaptchaProvider');
  }
  return context;
};
